<script>
import { mapGetters } from 'vuex'

export default {
  name: "CatMixin",
  components:{ 
  },
  data(){
    return {     
        transition:null,
        isMobile:false      
    }
  },
  computed: {
    ...mapGetters([
      'getPageTransition',
        'getIsMobile'
    ])
  },  
  created (){
    this.transition = this.getPageTransition;
    this.isMobile = this.getIsMobile;
  },
  watch : {
    getIsMobile(){
      this.isMobile = this.getIsMobile;
    }
  }
}
</script>